export default {
    intro: 'Use consonant hints and definitions to figure out the vocabulary!',
    meaning: 'Meaning',
    example: 'Example',
    table: {
        question: 'Vocabulary',
        emptyMessage: 'No content available.',
        answerRate: 'Answer Rate',
    },
    student: {
        selectionGuide: 'Can you figure out the word from these clues?',
        know: 'I know!',
        dontKnow: "I don't know",
        submit: 'Submit',
        next: 'Next',
        inputGuide: 'Type the word you think it is!',
        inputPlaceholder: 'Enter your answer',
        meaningN: 'Meaning {n}',
        imageN: 'Image {n}',
        videoN: 'Video {n}',
        additionalMaterials: 'More Resources',
    },
    result: {
        myAnswer: 'My answer:',
        know: 'I know',
        dontKnow: "Don't know",
        dontKnowBracket: "(Don't know)",
    },
    stats: {
        mostIncorrect: 'Most missed vocabulary',
        vocabulary: 'Vocabulary',
        meaning: 'Meaning',
        accuracy: 'Accuracy',
        moreN: 'and {n} more',
    },
    reactions: {
        knowSelect: [
            'Oh! You seem confident!',
            "Great! Let's check it out!",
            'Nice! Let me see if you got it right!',
            'Awesome! What word could it be?',
            "Cool! Let's see the answer!",
        ],
        correct: [
            "That's correct! Great job!",
            'Wow! You nailed it!',
            "Right! That's amazing!",
            'Excellent! You got it exactly right!',
            'Well done! Really impressive!',
        ],
        dontKnowSelect: [
            "That's okay! Let's figure it out together!",
            "Don't worry! The example sentences will help!",
            "No problem! Let's look at the clues!",
        ],
        maxAttempts: "It's okay. Let's find out what this word is together!",
        maxAttemptsNext: "Let's see what the word is, and move on to the next one!",
    },
};
